export default __webpack_public_path__ + "static/media/7.e21f1da9.svg";